module.exports = __webpack_public_path__ + "media/images/logo/product-longlife-44a4799003f69ad6d7f7e64f046650f2.png";